import React, {Component} from 'react';
import EngagementRateGraph from './engagement_rate_graph/';
import ScrollEffect from './../../lib/scroll-effect';

export default class PowerOfAuthenticity extends Component {
    constructor(){
        super();
        this.handleScrollEnter = this.handleScrollEnter.bind(this);
        this.displayGraph = this.displayGraph.bind(this);
        this.setTooltipPosition = this.setTooltipPosition.bind(this);
        this.handleRenderTooltip = this.handleRenderTooltip.bind(this);
        this.displayTooltip = this.displayTooltip.bind(this);
        this.displayStaticGraph = this.displayStaticGraph.bind(this);
        this.state = {
            renderedGraph: false,
            renderedTooltip: false,
            tooltipX: 170,
            tooltipY: 520
        }
    }

    handleScrollEnter(){
        this.setState({
            renderedGraph: true
        });
    }

    displayGraph(){
        const {renderedGraph} = this.state;

        return renderedGraph ? <EngagementRateGraph
            handleRenderTooltip={this.handleRenderTooltip}
            setTooltipPosition={this.setTooltipPosition} /> : null;
    }

    setTooltipPosition(x, y){
        this.setState({
            tooltipX: x,
            tooltipY: y
        });
    }

    handleRenderTooltip(){
        this.setState({
            renderedTooltip: true
        });
    }

    displayTooltip(){
        const {renderedTooltip, tooltipX, tooltipY} = this.state;
        const style = {
            bottom: tooltipY,
            left: tooltipX
        }

        return renderedTooltip ? (
            <div className='custom-tooltip' style={style}>
                <p>Discover, activate and nurture brand ambassadors to achieve 3-4x higher engagement rate and 70% cost savings</p>
            </div>
        ) : null;
    }

    displayStaticGraph(){
        const {displayStatic} = this.props;
        const graphImgMobile = require('images/brand_ambassadors/power_of_authenticity_graph_mobile.png');

        if(displayStatic){
            return(
                <div className='power-of-authenticity-graph-web-static'>
                    <img src={graphImgMobile} />
                </div>
            );
        } else {
            return(
                <div className='hide show@xs power-of-authenticity-graph-mobile'>
                    <img src={graphImgMobile} />
                </div>
            );
        }
    }

    render(){
        const graph = this.displayGraph();
        const tooltip = this.displayTooltip();
        const staticGraph = this.displayStaticGraph();

        return(
            <div className='gr-12 power-of-authenticity'>
                <div className='gr-12 power-of-authenticity-text'>
                    <h1>The power of authenticity</h1>
                    <p>Ambassadors are passionate and authentic consumers, looked to by their followers as a trusted source when it comes to brand recommendations.</p>
                </div>
                <div className='gr-12 power-of-authenticity-graph'>
                    <ScrollEffect animate="animating" callback={this.handleScrollEnter} duration={0} />
                    {graph}
                    {tooltip}
                </div>
                {staticGraph}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./web/js/components/brand_ambassadors/power_of_authenticity.js